module.exports = __webpack_public_path__ + "img/plus.58928c35.svg";